export const smeBaseName = "/business/finances";
export const agentBaseName = "/agent/finances";

export default {
  ApplicationSubmitted: `${smeBaseName}/ApplicationSubmitted`,
  applicantInfo: `${smeBaseName}/ApplicantInfo`,
  verifyOtp: `${smeBaseName}/VerifyOTP`,
  verifyEmailOtp: `${smeBaseName}/VerifyEmailOTP`,
  basicInformation: `${smeBaseName}/BasicInformation`,
  borrowAmount: `${smeBaseName}/BorrowAmount`,
  companyInfo: `${smeBaseName}/CompanyInfo`,
  stakeholdersInfo: `${smeBaseName}/StakeholdersInfo`,
  comeBackLoginVerification: `${smeBaseName}/ComeBackVerification`,
  MyApplications: `${smeBaseName}/MyApplications`,
  login: `${agentBaseName}/Login`,
  comeBackLogin: `${smeBaseName}/ComeBackLogin`,
  uploadDocuments: `${smeBaseName}/UploadDocuments`,
  SubmitApplication: `${smeBaseName}/SubmitApplication`,
  AECBcheck: `${smeBaseName}/AECB-FTS-Check`,
  FTScheck: `${smeBaseName}/FTScheck`,
  finalQuestions: `${smeBaseName}/FinalQuestions`,
  financeProductComparison: `${smeBaseName}`,
  detailedFinance: `${smeBaseName}/:financeType`,
  applicationOverview: `${smeBaseName}/:financeType/application-overview`,
  consentVerify: `${smeBaseName}/aecb-fts-consent`,
  aecbFtsAuthorize: `${smeBaseName}/aecb-fts-consent/authorize`,
  aecbFtsAuthorizeGenerated: `${smeBaseName}/aecb-fts-consent/verify-otp`,
  consentAuthorized: `${smeBaseName}/aecb-fts-consent/submitted`,
  uploadAdditionalDocumentsVerify: `${smeBaseName}/upload-additional-documents`,
  uploadAdditionalDocumentsVerifyGenerated: `${smeBaseName}/upload-additional-documents/verify-otp`,
  additionalDocuments: `${smeBaseName}/additional-documents`,
  additionalDocumentsSubmitted: `${smeBaseName}/additional-documents/submitted`,

  searchProspect: `${agentBaseName}/SearchProspect`,
  SearchedAppInfo: `${agentBaseName}/SearchedAppInfo/:id`,
  // userApplication: `${smeBaseName}/MyApplications`,
  applicationVerification: `${smeBaseName}/ApplicationVerification`,
  additionalDocumentSignatories: `${smeBaseName}/AdditionalDocumentSignatories`,
  companyInfoPE: `${smeBaseName}/post-eligibility/CompanyInfo`,
  stakeholdersInfoPE: `${smeBaseName}/post-eligibility/StakeholdersInfo`,
  uploadDocumentsPE: `${smeBaseName}/post-eligibility/UploadDocuments`,
  selectServices: `${smeBaseName}/SelectServices`,
  existingCustomer: `${smeBaseName}/ExistingCustomer`,
  SalesInitiate: `${smeBaseName}/SalesInitiate`,
  userVerify: `${smeBaseName}/authorize-agent`,
  userVerifyGenerated: `${smeBaseName}/authorize-agent/verify-otp`,
  userAuthorize: `${smeBaseName}/authorize`,
  userAuthorized: `${smeBaseName}/authorized`
};
